// import { yupResolver } from "@hookform/resolvers/yup";
// import BreadCrumbTable from "components/breadcrumb/BreadCrumbTable";
// import { useEffect, useState } from "react";
// import { Button, Card, Col, Form, Row } from "react-bootstrap";
// import { FormProvider, useForm } from "react-hook-form";
// import { useLocation, useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import { customSettings } from "utils/customConfig";
// import PageTitle from "utils/PageTitle";
// import * as yup from "yup";
// import { MarqueeMessagesAPI } from "../../../../api";
// import BasicInformation from "./BasicInformation";

// const schema = yup
//   .object({
//     message: yup.string(),
//     url: yup.string(),
//     order: yup.string(),
//     status: yup.boolean(),

//   })
//   .required();

// const AddMarqueeMessageTest = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [loading, setLoading] = useState(false);

//   const submittedValues = {};
//   const methods = useForm({
//     resolver: yupResolver(schema),
//     defaultValues: {},
//   });
//   const { handleSubmit, reset, setValue } = methods;

//   const onSubmit = async (data) => {
//     let myData = {
//       ...data,
//       id: location?.state?.id ?? 0, // Use nullish coalescing to handle undefined or null
//     };

//     // console.log(myData);

//     try {
//       if (location?.state) {
//         setLoading(true);
//         await MarqueeMessagesAPI.post(myData);
//         setLoading(false);
//         toast.success("Marquee Message Updated Successfully", {
//           position: customSettings.toastPosition,
//           autoClose: customSettings.toastClose,
//         });
//       } else {
//         setLoading(true);
//         await MarqueeMessagesAPI.post(myData);
//         setLoading(false);
//         toast.success("Marquee Message Created Successfully", {
//           position: customSettings.toastPosition,
//           autoClose: customSettings.toastClose,
//         });
//       }

//       // ------- Get all object keys form data and set empty values to reset ------------
//       const keys = Object.keys(data);
//       for (const key of keys) {
//         submittedValues[key] = "";
//       }
//       reset({ ...submittedValues });
//       navigate(-1);
//     } catch (error) {
//       toast.error("Something Went Wrong", {
//         position: customSettings.toastPosition,
//         autoClose: customSettings.toastClose,
//       });
//       console.log(error);
//     }
//   };

//   useEffect(() => {
//     if (location?.state) {
//       reset(location.state);
//     }
//   }, [setValue]);

//   return (
//     <>
//       <PageTitle name="Shopenze | Marquee Messages" />
//       <FormProvider {...methods}>
//         <Form onSubmit={handleSubmit(onSubmit)} noValidate>
//           <Card>
//             <Card.Header className="border-bottom">
//               <Row className="flex-between-center ">
//                 <Col md>
//                   <BreadCrumbTable
//                     title="Shopenze"
//                     subTitle="Marquee Messages"
//                   />
//                 </Col>
//                 <Col xs="auto">
//                   <Button
//                     variant="link"
//                     className="text-secondary fw-medium p-0 me-3"
//                     type="button"
//                     onClick={() => navigate(-1)}
//                   >
//                     Cancel
//                   </Button>
//                   <Button variant="primary" type="submit" disabled={loading}>
//                     Ok
//                   </Button>
//                 </Col>
//               </Row>
//             </Card.Header>
//             <BasicInformation />
//           </Card>
//         </Form>
//       </FormProvider>
//     </>
//   );
// };

// export default AddMarqueeMessageTest;



import { yupResolver } from "@hookform/resolvers/yup";
import BreadCrumbTable from "components/breadcrumb/BreadCrumbTable";
import { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { customSettings } from "utils/customConfig";
import PageTitle from "utils/PageTitle";
import * as yup from "yup";
import { MarqueeMessagesAPI } from "../../../../api";
import BasicInformation from "./BasicInformation";

// Validation Schema
const schema = yup.object({
  message: yup.string(),
  url: yup.string(),
  order: yup.string(),
  status: yup.boolean(),
});

const AddMarqueeMessageTest = ({ selected, setSelectedItem, onSuccess }) => {

  const [loading, setLoading] = useState(false);

  const submittedValues = {};
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: selected || {},
  });

  const { handleSubmit, reset, setValue } = methods;

  // // 🔥 Load selected row when user double-clicks
  // useEffect(() => {
  //   if (selected) {
  //     reset({
  //       message: selected.message,
  //       url: selected.url,
  //       order: selected.order,
  //       status: selected.status,
  //       id: selected.id,
  //     });
  //   } else {
  //     // Clear form when no selection
  //     reset({
  //       message: "",
  //       url: "",
  //       order: "",
  //       status: false,
  //       id: 0,
  //     });
  //   }
  // }, [selected, reset]);

  // Submit Handler
  const onSubmit = async (data) => {
    try {
      setLoading(true);
      await MarqueeMessagesAPI.post({
        ...data,
        id: data?.id ?? 0,
      });
      setLoading(false);

      toast.success(
        selected
          ? "Marquee Message Updated Successfully"
          : "Marquee Message Created Successfully",
        {
          position: "bottom-right",
          autoClose: customSettings.toastClose,
        }
      );

      // Clear form after success
      reset({
        message: "",
        url: "",
        order: "",
        status: false,
        id: 0,
      });
      setSelectedItem(null);

      onSuccess && onSuccess();

    } catch (error) {
      setLoading(false);
      toast.error("Something Went Wrong", {
        position: customSettings.toastPosition,
        autoClose: customSettings.toastClose,
      });
      console.log(error);
    }
  };

  useEffect(() => {
    reset(selected);
  }, [selected]);

  return (
    <>
      <PageTitle name="Shopenze | Marquee Messages" />

      <FormProvider {...methods}>
        <Form onSubmit={handleSubmit(onSubmit)} noValidate>
          <Card>
            <Card.Header className="border-bottom">
              <Row className="flex-between-center">
                <Col md>
                  <BreadCrumbTable title="Shopenze" subTitle="Marquee Messages" />
                </Col>

                <Col xs="auto">
                  <Button
                    variant="link"
                    className="text-secondary fw-medium p-0 me-3"
                    type="button"
                    onClick={() => {
                      setSelectedItem(null);
                      reset({
                        message: "",
                        url: "",
                        order: "",
                        status: false,
                        id: 0,
                      })
                    }
                    }
                  >
                    Cancel
                  </Button>

                  <Button variant="primary" type="submit" disabled={loading} >
                    Ok
                  </Button>
                </Col>
              </Row>
            </Card.Header>

            <BasicInformation selected={selected} />
          </Card>
        </Form>
      </FormProvider>
    </>
  );
};

export default AddMarqueeMessageTest;
